(function () {
  var priceDataPromise;

  function normalizeSku(value) {
    return String(value || '').trim().toUpperCase().replace(/\s+/g, '');
  }

  function skuCandidates(value) {
    var exact = normalizeSku(value);
    var candidates = exact ? [exact] : [];
    var withoutEu = exact.replace(/-?EU$/, '');
    if (withoutEu && candidates.indexOf(withoutEu) === -1) candidates.push(withoutEu);
    return candidates;
  }

  function resolveGroupPrices(data, group) {
    var groups = data && data.groups;
    if (!groups) return null;
    var prices = groups[group] || null;
    return prices;
  }

  function loadPriceData(url) {
    if (!priceDataPromise) {
      priceDataPromise = fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Price-break data could not be loaded.');
        return response.json();
      });
    }
    return priceDataPromise;
  }

  function formatMoney(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale || document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'EUR',
        currencyDisplay: 'symbol'
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '€ ' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function getTierIndex(thresholds, quantity) {
    var activeIndex = 0;
    thresholds.forEach(function (threshold, index) {
      if (quantity >= threshold) activeIndex = index;
    });
    return activeIndex;
  }

  function quantityLabel(thresholds, index) {
    var start = thresholds[index];
    var next = thresholds[index + 1];
    return next ? start + '–' + (next - 1) : start + '+';
  }

  function getQuantity(input) {
    var quantity = parseInt(input && input.value ? input.value : '1', 10);
    if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;
    return quantity;
  }

  function getBundleTotal(root) {
    var bundle = root.querySelector('.lwp-pair-bundle__form[data-bundle-price-cents]');
    if (!bundle) return 0;
    var bundlePrice = Number(bundle.dataset.bundlePriceCents || 0);
    var bundleInput = bundle.querySelector('.lwp-pair-bundle__qty-input');
    var bundleQuantity = parseInt(bundleInput && bundleInput.value ? bundleInput.value : '0', 10);
    if (!Number.isFinite(bundleQuantity) || bundleQuantity < 0) bundleQuantity = 0;
    return bundlePrice * bundleQuantity;
  }

  function updateCustomerPrice(root, table, thresholds, prices, data, input) {
    var quantity = getQuantity(input);
    var unitPrice = Number(prices[getTierIndex(thresholds, quantity)] || 0);
    if (!Number.isFinite(unitPrice) || unitPrice <= 0) return;

    var formattedUnitPrice = formatMoney(unitPrice, data.currency, table.dataset.locale);
    root.querySelectorAll('[data-lwp-desktop-total-price], [data-lwp-mobile-total-price]').forEach(function (priceElement) {
      if (!priceElement.dataset.lwpOriginalMainPriceCents) {
        priceElement.dataset.lwpOriginalMainPriceCents = priceElement.dataset.mainPriceCents || '';
      }
      priceElement.dataset.mainPriceCents = String(unitPrice);
      priceElement.dataset.lwpTierUnitPriceCents = String(unitPrice);
      priceElement.dataset.lwpTierUnitPrice = formattedUnitPrice;
      priceElement.setAttribute('data-lwp-tier-price', 'true');
      priceElement.setAttribute(
        'aria-label',
        formattedUnitPrice + (String(table.dataset.locale || '').toLowerCase().indexOf('de') === 0 ? ' Stückpreis' : ' unit price')
      );
      priceElement.classList.remove('is-updating');
      void priceElement.offsetWidth;
      priceElement.classList.add('is-updating');
    });

    root.querySelectorAll('[data-lwp-klarna-box]').forEach(function (klarnaBox) {
      klarnaBox.dataset.mainPriceCents = String(unitPrice);
    });

    var mainOrderTotal = unitPrice * quantity;
    var orderTotal = mainOrderTotal + getBundleTotal(root);
    var summary = root.querySelector('[data-lwp-qty-summary]');
    if (summary) {
      summary.textContent = quantity + ' × ' + formattedUnitPrice + ' = ' + formatMoney(mainOrderTotal, data.currency, table.dataset.locale);
    }
    var installment = Math.round(orderTotal / 3);
    var priceContext = root.querySelector('[data-lwp-desktop-total-price]') || table;
    root.querySelectorAll('[data-lwp-klarna-installment], [data-lwp-klarna-plan-installment]').forEach(function (element) {
      element.textContent = formatMoney(installment, data.currency, table.dataset.locale || priceContext.dataset.locale);
    });
    root.querySelectorAll('[data-lwp-klarna-total], [data-lwp-klarna-pay-full]').forEach(function (element) {
      element.textContent = formatMoney(orderTotal, data.currency, table.dataset.locale || priceContext.dataset.locale);
    });
  }

  function bindActiveTier(root, table, thresholds, prices, data) {
    var mainInput = root.querySelector('.lwp-qty input[type="number"], .lwp-mobile-sticky__qty input[type="number"]');

    function refresh(input) {
      input = input || mainInput;
      var quantity = getQuantity(input);
      var activeIndex = getTierIndex(thresholds, quantity);
      table.querySelectorAll('tbody tr').forEach(function (row, index) {
        row.classList.toggle('is-active', index === activeIndex);
        if (index === activeIndex) row.setAttribute('aria-current', 'true');
        else row.removeAttribute('aria-current');
      });
      updateCustomerPrice(root, table, thresholds, prices, data, input);
    }

    function scheduleRefresh(input) {
      window.requestAnimationFrame(function () { refresh(input || mainInput); });
    }

    root.querySelectorAll('.lwp-qty input[type="number"], .lwp-mobile-sticky__qty input[type="number"]').forEach(function (input) {
      input.addEventListener('input', function () { scheduleRefresh(input); });
      input.addEventListener('change', function () { scheduleRefresh(input); });
    });

    root.querySelectorAll('.lwp-pair-bundle__qty-input').forEach(function (bundleInput) {
      bundleInput.addEventListener('input', function () { scheduleRefresh(mainInput); });
      bundleInput.addEventListener('change', function () { scheduleRefresh(mainInput); });
    });

    refresh(mainInput);
  }

  function renderPriceBreaks(container, data) {
    var group = container.dataset.priceGroup;
    var groupPrices = resolveGroupPrices(data, group);
    if (!groupPrices) return;

    var prices;
    skuCandidates(container.dataset.sku).some(function (candidate) {
      if (groupPrices[candidate]) {
        prices = groupPrices[candidate];
        return true;
      }
      return false;
    });

    if (!prices || !prices.length) return;

    var thresholds = data.thresholds || [1, 10, 25, 50, 75, 100];
    var tbody = container.querySelector('[data-lwp-price-breaks-body]');
    if (!tbody) return;

    tbody.textContent = '';
    prices.forEach(function (price, index) {
      if (!Number.isFinite(price) || price <= 0) return;
      var row = document.createElement('tr');
      var quantityCell = document.createElement('td');
      var priceCell = document.createElement('td');
      quantityCell.className = 'lwp-price-breaks__quantity';
      priceCell.className = 'lwp-price-breaks__price';
      quantityCell.textContent = quantityLabel(thresholds, index);
      priceCell.textContent = formatMoney(price, data.currency, container.dataset.locale);
      row.dataset.lwpTierQuantity = String(thresholds[index]);
      row.tabIndex = 0;
      row.appendChild(quantityCell);
      row.appendChild(priceCell);
      tbody.appendChild(row);
    });

    if (!tbody.children.length) return;
    container.hidden = false;
    var root = container.closest('[data-led-wattz-product]') || document;
    var quantityInput = root.querySelector('.lwp-qty input[type="number"]');
    tbody.addEventListener('click', function (event) {
      var row = event.target.closest('tr[data-lwp-tier-quantity]');
      if (!row || !quantityInput) return;
      quantityInput.value = row.dataset.lwpTierQuantity;
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      quantityInput.focus();
    });
    tbody.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var row = event.target.closest('tr[data-lwp-tier-quantity]');
      if (!row) return;
      event.preventDefault();
      row.click();
    });
    bindActiveTier(root, container, thresholds, prices, data);
  }

  function initPriceBreaks(scope) {
    (scope || document).querySelectorAll('[data-lwp-price-breaks][data-price-group][data-price-data-url]').forEach(function (container) {
      if (container.dataset.priceBreaksInit === 'true') return;
      container.dataset.priceBreaksInit = 'true';
      loadPriceData(container.dataset.priceDataUrl)
        .then(function (data) { renderPriceBreaks(container, data); })
        .catch(function () { container.hidden = true; });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initPriceBreaks(document); });
  document.addEventListener('shopify:section:load', function (event) { initPriceBreaks(event.target); });
})();
